import { Alert, Space } from "melco-ui";
import { useTranslation } from "react-i18next";

import { useConfirm } from "melco-shared-logic";
import { Drawer as DrawerType } from "../../hooks/drawer/useGenericDrawer";
import { useEffect } from "react";
import { useCancelLicense } from "../../hooks/licenses/useCancelLicense";

export interface CancelLicenseActionButtonInterface {
  licenseSerialNumberToCancel: string;
  licenseProductCode: string;
  CancellationReason: string;
  subCancelledDate?: Date | null;
}

type CancelLicenseActionButtonProps = {
  cancelActionDetails: CancelLicenseActionButtonInterface;
  referencesDrawer?: DrawerType;
  openAskConirmationBoxTrigger: boolean;
  onCloseDrawer: () => void;
};

export const CancelLicenseActionButton: React.FC<
  CancelLicenseActionButtonProps
> = ({
  openAskConirmationBoxTrigger,
  cancelActionDetails,

  onCloseDrawer,
}) => {
    const { t } = useTranslation();

    //    const shouldShowWarning = useShouldShowWarning();
    const cancelLicense = useCancelLicense();

    const confirmCancel = useConfirm(
      async () => {
        if (cancelActionDetails.licenseSerialNumberToCancel) {
          await cancelLicense(
            cancelActionDetails
          );

          onCloseDrawer();
        }
      },
      {
        translationPrefix: ["licenses.basic.detail", "cancel"].join("."),

        //  translationPrefix: "licenses.basic.detail.cancel",
        translationOptions: {
          count: 1,
        },
        content: (
          <Space direction="vertical" size="small">
            <div>
              {t("licenses.basic.actions.cancel.confirmation.message_one")}
            </div>
            <Alert
              type="warning"
              withBackground
              description={t(
                "licenses.basic.actions.cancel.confirmation.warning_one"
              )}
              showIcon={false}
              onClose={() => { }}
              afterClose={() => { }}
              onClick={() => { }}
            />
          </Space>
        ),
      }
    );

    useEffect(() => {
      confirmCancel();
    }, [openAskConirmationBoxTrigger]);

    return <></>;
  };
